import { CSSProperties } from 'react';
import { COLORS } from '~/data/ui/colors';

const useStyle = {
  root: {
    display: 'flex',
    gap: '10px',
    border: `1px solid rgba(0, 0, 0, 0.23)`,
    borderRadius: '4px',
    height: '56px',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      border: `1px solid  ${COLORS.black.dark}`,
    },
    padding: '0 16px',
  },
  isOpenStyle: {
    display: 'flex',
    gap: '10px',
    border: `1px solid ${COLORS.primary.main}`,
    borderRadius: '4px',
    height: '56px',
    alignItems: 'center',
    padding: '0 16px',
  },
  error: {
    border: `1px solid ${COLORS.red.error}`,
  },
};

export default useStyle;

export const textCustomStyle: CSSProperties = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  color: COLORS.gray.dark,
};

export const arrowSize = {
  height: '25px',
  width: '15px',
};
